import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { ConfigService } from "../../../config/config.service";
import { AuthenticationService } from "./authentication.service";

@Injectable({
  providedIn: 'root'
})
export class AuthenticationGuard  {

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private config: ConfigService
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (!this.authenticationService.getUserToken().isLoggedIn()) {
      //redirect to login
      this.config.getConfig().subscribe(config => {
        this.router.navigate([config.postLogin], { queryParams: { redirectURI: state.url } });
      });
    } else {
      return true;
    }
  }
}
